import { setHeaderCartCount } from '../utils/cart-count.js';

class Cart {
  constructor() {
    this.el = document.querySelector('[js-ird-cart]');
    this.isUpdating = false;

    if (!this.el) return;

    this.onClick = this.onClick.bind(this);
    this.attachEvents();
  }

  attachEvents() {
    if (!this.el) return;
    this.el.addEventListener('click', this.onClick);
  }

  onClick(event) {
    const qtyButton = event.target.closest('[js-ird-cart-qty]');
    if (qtyButton) {
      event.preventDefault();
      this.handleQty(qtyButton);
      return;
    }

    const removeButton = event.target.closest('[js-ird-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      this.handleRemove(removeButton);
    }
  }

  handleQty(button) {
    if (this.isUpdating) return;

    const item = button.closest('.ird-cart__item');
    const input = item?.querySelector('.ird-cart__qty input');
    const line = Number(item?.dataset.line);
    const delta = Number(button.dataset.delta || 0);
    const currentQty = Number(input?.value || 0);
    const nextQty = Math.max(0, currentQty + delta);

    if (!line || nextQty === currentQty) return;
    this.updateLine(line, nextQty, item);
  }

  handleRemove(button) {
    if (this.isUpdating) return;

    const item = button.closest('.ird-cart__item');
    const line = Number(item?.dataset.line);
    if (!line) return;

    this.updateLine(line, 0, item);
  }

  async updateLine(line, quantity, item) {
    const root = this.el;
    if (!root) return;

    this.isUpdating = true;
    root.classList.add('-loading');
    if (item) item.classList.add('-loading');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
      });

      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      setHeaderCartCount(cart?.item_count || 0);
      document.dispatchEvent(
        new CustomEvent('ird:cart:updated', {
          detail: { itemCount: cart?.item_count || 0 },
        })
      );
      await this.refreshSection();
    } catch (error) {
      console.error('[IRD Cart] update error:', error);
    } finally {
      this.isUpdating = false;
      if (this.el) this.el.classList.remove('-loading');
    }
  }

  async refreshSection() {
    if (!this.el) return;

    const sectionId = this.el.dataset.sectionId;
    if (!sectionId) return;

    const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
    if (!response.ok) throw new Error('Cart section refresh failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextEl = doc.querySelector('[js-ird-cart]');

    if (!nextEl || !this.el) return;

    this.el.replaceWith(nextEl);
    this.el.removeEventListener('click', this.onClick);
    this.el = nextEl;
    this.attachEvents();
  }
}

export default Cart;
